import { jwtDecode } from 'jwt-decode';
import { PHYSICAL_DIRECTIONS } from 'src/utils/physical-api';
import { ORDER_STATUS_OPTIONS } from 'src/_mock';

const auth = JSON.parse(localStorage.getItem('token'));
let decoded = '';
if (auth) {
  decoded = jwtDecode(auth);
}

const PHYSICAL_ONLY_STATUSES = [
  'RECEIVED IN GE WAREHOUSE',
  'PREPARED FOR SHIPMENT',
  'ON THE WAY FROM GE WAREHOUSE',
  'DROPPED IN GE AIRPORT FACILITY',
  'AIR SHIPPED FROM GE',
  'IN TRANSIT',
  'ARRIVED IN GE',
  'ARRIVED IN US',
  'CUSTOMS PROCESSING',
  'CUSTOMS HOLD',
  'DOCUMENTATION REQUIRED',
  'CUSTOMS EXAMINATION',
  'DUTIES / TAXES REQUIRED',
  'RELEASED FROM CUSTOMS',
  'READY FOR PICKUP',
  'READY FOR DELIVERY',
  'PREPARED FOR DOMESTIC DELIVERY',
  'HANDED TO DELIVERY PARTNER',
  'IN DOMESTIC TRANSIT',
  'RESTRICTED ITEM',
  'RETURNED',
];

const STATUS_OPTIONS = [
  ...ORDER_STATUS_OPTIONS,
  ...PHYSICAL_ONLY_STATUSES.map((value) => ({ value, label: value })),
];

export const PHYSICAL_STATUSES = [
  'AWAITING',
  'RECEIVED IN US WAREHOUSE',
  'RECEIVED IN GE WAREHOUSE',
  'PREPARED FOR SHIPMENT',
  'ON THE WAY FROM US WAREHOUSE',
  'ON THE WAY FROM GE WAREHOUSE',
  'DROPPED IN US AIRPORT FACILITY',
  'DROPPED IN GE AIRPORT FACILITY',
  'AIR SHIPPED FROM US',
  'AIR SHIPPED FROM GE',
  'IN TRANSIT',
  'ARRIVED IN GE',
  'ARRIVED IN US',
  'CUSTOMS PROCESSING',
  'CUSTOMS HOLD',
  'DOCUMENTATION REQUIRED',
  'CUSTOMS EXAMINATION',
  'DUTIES / TAXES REQUIRED',
  'RELEASED FROM CUSTOMS',
  'RECEIVED IN TBILISI WAREHOUSE',
  'READY FOR PICKUP',
  'PICKED UP',
  'CHECKED',
  'READY FOR DELIVERY',
  'OUT FOR DELIVERY',
  'PREPARED FOR DOMESTIC DELIVERY',
  'HANDED TO DELIVERY PARTNER',
  'IN DOMESTIC TRANSIT',
  'DELIVERED',
  'ON HOLD',
  'NOT IDENTIFIED',
  'RESTRICTED ITEM',
  'DAMAGED',
  'DELAYED',
  'FAILED DELIVERY',
  'RETURNED',
  'CANCELED',
  'LOST PARCEL',
];

export const ORIGIN_WAREHOUSE_STATUS = {
  [PHYSICAL_DIRECTIONS.USA_GE]: 'RECEIVED IN US WAREHOUSE',
  [PHYSICAL_DIRECTIONS.GE_USA]: 'RECEIVED IN GE WAREHOUSE',
};

export const initialStatusesFor = (direction) => [
  'AWAITING',
  ORIGIN_WAREHOUSE_STATUS[direction],
  'ON HOLD',
  'NOT IDENTIFIED',
  'DAMAGED',
];
const TIME_SLOT_FOR_ORDER =
  decoded?.location === 'Georgia'
    ? [
        { value: 'all', label: 'All' },
        { value: '9:00-12:00', label: '9AM TO 12PM' },
        { value: '12:00-15:00', label: '12PM TO 15PM' },
        { value: '15:00-19:00', label: '15PM TO 19PM' },
        { value: '19:00-22:00', label: '19PM TO 22PM' },
        { value: '22:00-01:00', label: '22PM TO 1AM' },
      ]
    : [];

const filterKeys = [
  {
    key: 'status',
    label: 'Status',
    options: STATUS_OPTIONS,
  },
  {
    key: 'declaration_status',
    label: 'Declaration Status',
    options: [
      { value: 'DECLERED', label: 'Declared' },
      { value: 'NOT DECLERED', label: 'Not Declared' },
    ],
  },
  {
    key: 'custom_status',
    label: 'Custom Status',
    options: [
      { value: '0', label: '0' },
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
    ],
  },
  {
    key: 'delivery_status',
    label: 'Delivery Status',
    options: [
      { value: 'DELIVERED', label: 'Delivered' },
      { value: 'NOT DELIVERED', label: 'Not Delivered' },
    ],
  },
  {
    key: 'vatPaymentAuto',
    label: 'Yellow Pay by user',
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
  },
  {
    key: 'DeclarationPaymentAuto',
    label: 'RS Fee Pay GZ',
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
  },
  {
    key: 'NeedsCustom',
    label: 'NeedsCustom',
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
  },
  {
    key: 'vat',
    label: 'Yellow status',
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
  },
  {
    key: 'invoiceStatus',
    label: 'invoiceStatus',
    options: [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
  },
  {
    key: 'vat_payment_status',
    label: 'Yellow Pay by GZ',
    options: [
      { value: true, label: 'YES' },
      { value: false, label: 'NO' },
    ],
  },
  {
    key: 'deliveryExtraMethod',
    label: 'Delivery Method',
    options: [
      { value: 'TBILISI', label: 'Tbilisi' },
      { value: 'REGION', label: 'Region' },
      { value: 'PICKUP', label: 'Pickup' },
      { value: 'none', label: 'No Delivery Method' },
    ],
  },
];

const OTHER_STATUS_OPTIONS_FOR_ORDER = [
  { value: '', label: 'All' },
  { value: 'RECEIVED IN US WAREHOUSE', label: 'RECEIVED IN US WAREHOUSE' },
  { value: 'CUSTOMS CLEARANCE', label: 'CUSTOMS CLEARANCE' },
  { value: 'RECEIVED IN TBILISI WAREHOUSE', label: 'RECEIVED IN TBILISI WAREHOUSE' },
];
/* eslint-disable import/no-mutable-exports */
let TABLE_HEAD = [];

if (decoded?.location === 'Georgia') {
  TABLE_HEAD = [
    { id: 'tracking_number', label: 'Tracking', width: 160 },
    { id: 'room_number', label: 'Room', width: 140 },
    { id: 'weight', label: 'Weight', width: 140 },
    { id: 'NeedsCustom', label: 'Custom', width: 120 },
    { id: 'declaration_status', label: 'declaration', width: 120 },
    { id: 'nusxa', label: 'nusxa', width: 120 },
    { id: 'decSum', label: 'decSum', width: 90 },
    { id: 'pallet', label: 'pallet', width: 90 },
    { id: 'custom_status', label: 'custom_status', width: 120 },
    { id: 'countryChinaUsa', label: 'Country', width: 120 },
    { id: 'branch', label: 'Branch', width: 90 },
    { id: 'status', label: 'Status', width: 120 },
    { id: '', width: 88 },
  ];
} else if (decoded?.location === 'China') {
  TABLE_HEAD = [
    { id: 'tracking_number', label: 'Tracking', width: 160 },
    { id: 'room_number', label: 'Room', width: 140 },
    { id: 'weight', label: 'Weight', width: 140 },
    { id: 'declaration_status', label: 'declaration', width: 120 },
    { id: 'decSum', label: 'decSum', width: 90 },
    { id: 'pallet', label: 'pallet', width: 90 },
    { id: 'branch', label: 'Branch', width: 90 },
    { id: 'status', label: 'Status', width: 120 },
    { id: '', width: 88 },
  ];
} else {
  TABLE_HEAD = [
    { id: 'tracking_number', label: 'Tracking', width: 160 },
    { id: 'room_number', label: 'Room', width: 140 },
    { id: 'weight', label: 'Weight', width: 140 },
    { id: 'declaration_status', label: 'declaration', width: 120 },
    { id: 'decSum', label: 'decSum', width: 90 },
    { id: 'pallet', label: 'pallet', width: 90 },
    { id: 'status', label: 'Status', width: 120 },
    { id: '', width: 88 },
  ];
}

const defaultFilters = {
  role: [],
};

let tableNames = [];

if (decoded?.location === 'Georgia') {
  tableNames = [
    { id: 'tracking_number', label: 'Tracking' },
    { id: 'room_number', label: 'Room' },
    { id: 'weight', label: 'Weight' },
    { id: 'NeedsCustom', label: 'Custom' },
    { id: 'declaration_status', label: 'declaration' },
    { id: 'nusxa', label: 'Nusxa' },
    { id: 'decSum', label: 'decSum' },
    { id: 'pallet', label: 'pallet' },
    { id: 'custom_status', label: 'custom_status' },
    { id: 'countryChinaUsa', label: 'Country' },
    { id: 'branch', label: 'Branch', width: 90 },
    { id: 'status', label: 'Status' },
  ];
} else if (decoded?.location === 'China') {
  tableNames = [
    { id: 'tracking_number', label: 'Tracking' },
    { id: 'room_number', label: 'Room' },
    { id: 'weight', label: 'Weight' },
    { id: 'declaration_status', label: 'declaration' },
    { id: 'decSum', label: 'decSum' },
    { id: 'pallet', label: 'pallet' },
    { id: 'branch', label: 'Branch', width: 90 },
    { id: 'status', label: 'Status' },
  ];
} else {
  tableNames = [
    { id: 'tracking_number', label: 'Tracking' },
    { id: 'room_number', label: 'Room' },
    { id: 'weight', label: 'Weight' },
    { id: 'declaration_status', label: 'declaration' },
    { id: 'decSum', label: 'decSum' },
    { id: 'pallet', label: 'pallet' },
    { id: 'status', label: 'Status' },
  ];
}

// dashboard statuses 2

const statusCreate = ['RECEIVED IN US WAREHOUSE', 'NOT IDENTIFIED', 'ON HOLD', 'DAMAGED'];

const status = [];
if (auth) {
  if (decoded.location === 'USA') {
    const statusArr = [
      'AWAITING',
      'RECEIVED IN US WAREHOUSE',
      'ON HOLD',
      'NOT IDENTIFIED',
      'DAMAGED',
      'ON THE WAY FROM US WAREHOUSE',
      'DROPPED IN US AIRPORT FACILITY',
      'AIR SHIPPED FROM US',
      'DELAYED',
    ];
    status.push(...statusArr);
  }
  if (decoded.location === 'Georgia') {
    const statusArr = [
      'AWAITING',
      'RECEIVED IN US WAREHOUSE',
      'ON HOLD',
      'NOT IDENTIFIED',
      'DAMAGED',
      'ON THE WAY FROM US WAREHOUSE',
      'DROPPED IN US AIRPORT FACILITY',
      'AIR SHIPPED FROM US',
      'DELAYED',
      'CUSTOMS CLEARANCE',
      'CUSTOMS EXPERTISE',
      'RECEIVED IN TBILISI WAREHOUSE',
      'OUT FOR DELIVERY',
      // 'FAILED DELIVERY ATTEMPT',
      'DELIVERED',
      'CANCELED',
      'DEADLINE FOR THE CUSTOMS CLEARANCE COMPLETION',
      'NEEDS TO BE TRANSFERRED TO GOVERNMENT',
      'TRANSFERRED TO GOVERNMENT',
      'LOST PARCEL',
      'DELETED',
      'PICKED UP',
      'CHECKED',
      'FAILED DELIVERY',
      'NOT DECLARED',
      'RECEIVED IN CHINA WAREHOUSE',
      'AIR SHIPPED FROM CHINA',
      'GROUND SHIPPED FROM CHINA',
      'SEND TO REGION',
    ];
    status.push(...statusArr);
  }
  if (decoded.location === 'China') {
    const statusArr = [
      'AWAITING',
      'RECEIVED IN CHINA WAREHOUSE',
      'ON HOLD',
      'NOT IDENTIFIED',
      'DAMAGED',
      'AIR SHIPPED FROM CHINA',
      'GROUND SHIPPED FROM CHINA',
      'DELAYED',
    ];
    status.push(...statusArr);
  }
}

const trackingInformation = [
  {
    name: 'tracking_number',
    width: '48%',
    label: 'Tracking',
  },
  // {
  //   name: 'tracking_number_2',
  //   width: '48%',
  //   label: 'Traking 2',
  // },
  {
    name: 'room_number',
    width: '48%',
    label: 'Room Number',
  },
];

const pickupRegions = [
  { id: 'brooklyn', label: 'Brooklyn' },
  { id: 'new-jersey', label: 'New Jersey' },
  { id: 'queens', label: 'Queens' },
  { id: 'connecticut', label: 'Connecticut' },
  { id: 'bronx', label: 'Bronx' },
  { id: 'long-island', label: 'Long Island' },
  { id: 'philadelphia', label: 'Philadelphia Area' },
];

const orderDetails =
  decoded.location === 'Georgia'
    ? [
        {
          name: 'weight',
          width: '96%',
          // type: 'number',
          label: 'weight',
        },
        {
          name: 'len',
          width: '48%',
          // type: 'number',
          label: 'length',
        },
        {
          name: 'width',
          width: '48%',
          // type: 'number',
          label: 'width',
        },
        {
          name: 'height',
          width: '48%',
          // type: 'number',
          label: 'height',
        },
        {
          name: 'volume',
          width: '48%',
          // type: 'number',
          label: 'volume',
        },
        {
          name: 'price_gz',
          width: '96%',
          label: 'price_gz',
        },
      ]
    : [
        {
          name: 'weight',
          width: '96%',
          // type: 'number',
          label: 'weight',
        },
        {
          name: 'len',
          width: '24%',
          // type: 'number',
          label: 'length',
        },
        {
          name: 'width',
          width: '24%',
          // type: 'number',
          label: 'width',
        },
        {
          name: 'height',
          width: '24%',
          // type: 'number',
          label: 'height',
        },
        {
          name: 'volume',
          width: '24%',
          // type: 'number',
          label: 'volume',
        },
      ];

const declaration = [
  {
    name: 'declaration_id_for_vat',
    label: 'Yellow declaration ID',
    type: 'number',
    width: '96%',
    req: false,
  },
  {
    name: 'vat_amount',
    label: 'Yellow amount',
    type: 'number',
    width: '96%',
    req: false,
  },
];

const additionalInformation = [
  // {
  //   name: 'branch_id',
  //   width: '96%',
  //   label: 'Branch ID',
  // },
  {
    name: 'comment',
    width: '96%',
    label: 'Comment',
  },
];
const time_slot_select = [
  {
    id: '9:00-12:00',
    name: '9AM TO 12PM',
    value: '9:00-12:00',
  },
  {
    id: '12:00-15:00',
    name: '12PM TO 15PM',
    value: '12:00-15:00',
  },
  {
    id: '15:00-19:00',
    name: '15PM TO 19PM',
    value: '15:00-19:00',
  },
  {
    id: '19:00-22:00',
    name: '19PM TO 22PM',
    value: '19:00-22:00',
  },
  {
    id: '22:00-01:00',
    name: '22PM TO 1AM',
    value: '22:00-01:00',
  },
];

const status_colors = {
  ACTIVE: ['#22C55E29', '#118D57'],
  INACTIVE: ['#919EAB29', '#637381'],
  SUSPENDED: ['#FFAB0029', '#B76E00'],
  CLOSED: ['#FF563029', '#B71D18'],

  PLACED: ['#22C55E29', '#118D57'],
  PROCESSING: ['#FF563029', '#B71D18'],
  SHIPPED: ['#FFAB0029', '#B76E00'],
  OUT_FOR_DELIVERY: ['#DDF4FA', '#1A6C9C'],
  RETURN_TO_SENDER: ['#919EAB29', '#637381'],
  DELAYED: ['#919EAB29', '#637381'],
  CANCELLED: ['#919EAB29', '#637381'],
  NO_TRACKING_OR_ROOM: ['#919EAB29', '#637381'],
  DELETED: ['#919EAB29', '#637381'],

  AWAITING: ['#919EAB29,#637381'],
  RECEIVED_IN_US_WAREHOUSE: ['#919EAB29,#637381'],
  HOLD_IN_US_WAREHOUSE: ['#919EAB29,#637381'],
  DAMAGED: ['#919EAB29,#637381'],
  DROPPED_IN_US_AIRPORT_FACILITY: ['#919EAB29,#637381'],
  AIR_SHIPPED_FROM_US: ['#919EAB29,#637381'],
  CUSTOMS_CLEARANCE: ['#919EAB29,#637381'],
  CUSTOMS_EXPERTISE: ['#919EAB29,#637381'],
  RECEIVED_IN_TBILISI_WAREHOUSE: ['#919EAB29,#637381'],
  // FAILED_DELIVERY_ATTEMPT: ['#919EAB29,#637381'],
  DELIVERED: ['#919EAB29,#637381'],
  CANCELED: ['#919EAB29,#637381'],
  UNCLEAR_ORDER: ['#919EAB29,#637381'],
  ACTION_NEEDED: ['#919EAB29,#637381'],
  NEEDS_CUSTOM_CLEARANCE: ['#919EAB29,#637381'],
  DEADLINE_FOR_CUSTOMS_CLEARANCE_COMPLETION: ['#919EAB29,#637381'],
  NEEDS_TO_BE_TRANSFERRED_TO_GOVERNMENT: ['#919EAB29,#637381'],
  TRANSFERRED_TO_GOVERNMENT: ['#919EAB29,#637381'],
  LOST_PARCEL: ['#919EAB29,#637381'],
};
// deliveryTypes.js
export const DeliveryTypes = {
  Tbilisi_Pickup: 'Tbilisi_Pickup',
  Tbilisi_Delivery: 'Tbilisi_Delivery',
  Region: 'Region',
  NY_Pickup: 'NY_Pickup',
  NY_Delivery: 'NY_Delivery',
  US_Region: 'US_Region',
};

export const deliveryTypeOptions = [
  { value: DeliveryTypes.Tbilisi_Pickup, label: 'Tbilisi Pickup' },
  { value: DeliveryTypes.Tbilisi_Delivery, label: 'Tbilisi Delivery' },
  { value: DeliveryTypes.Region, label: 'Region' },
];

export const DELIVERY_OPTIONS_BY_DIRECTION = {
  [PHYSICAL_DIRECTIONS.USA_GE]: deliveryTypeOptions,
  [PHYSICAL_DIRECTIONS.GE_USA]: [
    { value: DeliveryTypes.NY_Pickup, label: 'NY Pickup' },
    { value: DeliveryTypes.NY_Delivery, label: 'NY Delivery' },
    { value: DeliveryTypes.US_Region, label: 'US Region' },
  ],
};

export {
  STATUS_OPTIONS,
  TABLE_HEAD,
  defaultFilters,
  tableNames,
  status,
  trackingInformation,
  orderDetails,
  additionalInformation,
  status_colors,
  OTHER_STATUS_OPTIONS_FOR_ORDER,
  TIME_SLOT_FOR_ORDER,
  time_slot_select,
  statusCreate,
  declaration,
  filterKeys,
  pickupRegions,
};
